export enum EAuthMethod {
  PASSWORD = 'PASSWORD',
  OIDC = 'OIDC',
}

export type TLoginMethodResponse = {
  method: EAuthMethod
}
